import React from "react";
import { styles } from "../../stylesheets/simulateurs.css";
import ButtonYesno from "../../components/buttons/button.yesno.js";
import Simulateur89 from "../../views/simulateurs/simulateur.A2.15/simulateur.A2.15";
import SimulateurA216 from "../../views/simulateurs/simulateur.A2.16/simulateur.A2.16";
import BadgeNouveau from "../texts/BadgeNouveau.js";

function CautionParticuliers(props) {
  const handleChange = async (setter, value, key) => {
    setter(value);
    if (props.handleChange) {
      props.handleChange(setter, value, key);
    }
  };
  const handleDependance89 = (obj) => {
    props.handleChange(null, obj, 'simu89');
  };
  const handleDependance90 = (obj) => {
    props.handleChange(null, obj, 'simu90');
  };
  // Use parent state values instead of local state
  const sansGarantieHypo = props.sansGarantieHypo || 0;
  const avecGarantieHypo = props.avecGarantieHypo || 0;

  return (
    <>
      <div className="cardRow">
        <div style={styles.cardElemVerticalyCenter}>
          Y a-t-il un cautionnement sans garantie hypothécaire ?
          <BadgeNouveau cliquable={false}/>
        </div>
        <ButtonYesno
          handleChange={handleChange}
          setter={props.setSansGarantieHypo}
          fieldUndefined={false}
          defaultValue={0}
        />
      </div>
      
      {parseInt(sansGarantieHypo) === 1 && (
        <Simulateur89
          simulateur={props.simulateur}
          isParent={false}
          departementId={props.departementId}
          dependances={handleDependance89}
          montantPret={props.montantPret}
        />
      )}

      <div className="cardRow">
        <div style={styles.cardElemVerticalyCenter}>
          Y a-t-il un cautionnement avec garantie hypothécaire ?
          <BadgeNouveau cliquable={false}/>
        </div>
        <ButtonYesno
          handleChange={handleChange}
          setter={props.setAvecGarantieHypo}
          fieldUndefined={false}
          defaultValue={0}
        />
      </div>

      {parseInt(avecGarantieHypo) === 1 && (
        <SimulateurA216
          simulateur={props.simulateur}
          isParent={false}
          departementId={props.departementId}
          dependances={handleDependance90}
          montantPret={props.montantPret}
        />
      )}
    </>
  );
}

export default CautionParticuliers;
